module.exports = "/_next/static/images/consultingBusinessServicesHeroSection-05daf6ffcc16e248349b744137392429.webp";